import React from 'react'

import { Animate, CubeDraft, Hexagon3d, Image, Text, Texture } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import CapabilityGroup from './Components/CapabilityGroup/CapabilityGroup'

// Marketing chips. Each entry pairs a Triangle UI icon component with its label; the icons
// are decorative (aria-hidden) since the label already names the capability.
const CREATE_CAPABILITIES = [
  { Icon: Image, label: 'Image to 3D' },
  { Icon: Text, label: 'Text to 3D' },
]

const ENHANCE_CAPABILITIES = [
  { Icon: Hexagon3d, label: 'Remesh' },
  { Icon: Texture, label: 'Texture' },
  { Icon: CubeDraft, label: 'Segment' },
  { Icon: Animate, label: 'Animate' },
]

function HeroIntro() {
  return (
    <div className="ai-sub-landing__hero-intro">
      {/* Shared AI gradient referenced by the capability icons and the "Try Free Generations"
          sparkle (SVG stroke/fill cannot take a CSS gradient, so it needs a real <linearGradient>). */}
      <svg className="ai-sub-landing__gradient-defs" width="0" height="0" aria-hidden="true" focusable="false">
        <defs>
          <linearGradient id="ai-sub-landing-ai-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop className="ai-sub-landing__gradient-stop--start" offset="0%" />
            <stop className="ai-sub-landing__gradient-stop--mid" offset="55%" />
            <stop className="ai-sub-landing__gradient-stop--end" offset="100%" />
          </linearGradient>
        </defs>
      </svg>
      <div className="ai-sub-landing__hero-heading">
        <h1 className="ai-sub-landing__hero-title cgt-heading-600">
          Create Stunning 3D Models with{' '}
          <span className="ai-sub-landing__hero-title-accent">CGTrader AI</span>
        </h1>
        <p className="ai-sub-landing__hero-subtitle cgt-body-md">
          Turn ideas into high-quality 3D models in minutes. Generate, enhance, and customize assets
          with powerful AI tools.
        </p>
      </div>
      <div className="ai-sub-landing__capabilities">
        <CapabilityGroup label="Create 3D Models" capabilities={CREATE_CAPABILITIES} />
        <CapabilityGroup label="Enhance 3D Models" capabilities={ENHANCE_CAPABILITIES} />
      </div>
    </div>
  )
}

export default HeroIntro
